import { Grid, Typography, Box, Slider } from "@material-ui/core";

import { DisplayRowField } from "./DisplayRowField";

export const defaultMarks = [
  {
    value: 0,
    label: "0",
  },
  {
    value: 100,
    label: "100",
  },
];

export const calcRiskIndex = (t, riskIndexValue) => {
  if (riskIndexValue >= 0 && riskIndexValue < 20) return t("levels.veryLow");
  if (riskIndexValue >= 20 && riskIndexValue < 40) return t("levels.relativelyLow");
  if (riskIndexValue >= 40 && riskIndexValue < 60) return t("levels.relativelyModerate");
  if (riskIndexValue >= 60 && riskIndexValue < 80) return t("levels.relativelyHigh");
  if (riskIndexValue >= 80 && riskIndexValue <= 100) return t("levels.veryHigh");
  return "Not available";
};

export const gridForComputedIndex = (
  t,
  selectedProperties,
  riskScore,
  riskIndexText,
  nationalAverageValue,
  nationalAverageMarks,
  nationalPercentileMarks,
  title,
) => {
  return (
    <>
      <DisplayRowField label={t("agriculture.municipality")} value={selectedProperties?.COMUNE} />

      <DisplayRowField label={t("agriculture.province")} value={selectedProperties?.PROVINCIA} />

      <DisplayRowField label={t("agriculture.region")} value={selectedProperties?.REGIONE} />

      <Typography component="div">
        <Box fontWeight="fontWeightBold" mt={2} mb={2}>
          {title} : {riskScore}
        </Box>
      </Typography>

      <Box mt={1}>
        <Typography id="risk-index" variant="body2" gutterBottom>
          {t("climateIndex.riskIndex")}:
        </Typography>
        <Slider value={riskScore} aria-labelledby="risk-index" marks={nationalPercentileMarks} disabled />
      </Box>

      <Box mt={1}>
        <Typography id="national-average" variant="body2" gutterBottom>
          {t("climateIndex.nationalAverage")}:
        </Typography>
        <Slider
          value={nationalAverageValue}
          aria-labelledby="national-average"
          marks={nationalAverageMarks}
          disabled
        />
        <Typography variant="caption" gutterBottom>
          {t("climateIndex.theRiskIndexIs")}
          <strong> {riskIndexText} </strong>
          {t("climateIndex.forCommune")}
          <strong>{selectedProperties?.COMUNE}</strong> {t("climateIndex.comparedTheRestOfItaly")}
        </Typography>
      </Box>

      <Typography component="div">
        <Box fontWeight="fontWeightBold" mt={2} mb={2}>
          {t("climateIndex.hazardTypeRiskRatings")}:
        </Box>
      </Typography>
    </>
  );
};

export const gridForHazard = (t, label, scoreValue, value, allocation) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={3}>
        <Typography variant="body2" gutterBottom>
          {label}:
        </Typography>
      </Grid>

      <Grid item xs={9}>
        <DisplayRowField label={t("climateIndex.score")} value={scoreValue} />

        <DisplayRowField label={t("climateIndex.value")} value={value} />

        <DisplayRowField label={t("climateIndex.allocation")} value={allocation} />
      </Grid>
    </Grid>
  );
};
